// Pure lane rules for the v2 practical-lesson routes. No Phaser, no config imports.
//
// A route has two lanes, named by which way you're facing when you belong in them: driving
// left, your own lane is 'left' (the near lane); driving right (after a U-turn, or on a
// route segment that runs the other way), it's 'right'. `lane`, in a driving state, is
// simply which of the two the car currently occupies — it need not match `facing` while a
// lane change is in flight, which is exactly the case `laneChangeAllowed` exists to guard.

/** Which lane you belong in, given which way you're facing. */
export function correctLane(facing) {
  return facing === 'left' ? 'left' : 'right';
}

/** The lane that isn't this one. */
export function otherLane(lane) {
  return lane === 'left' ? 'right' : 'left';
}

/** May a lane change start? Not while one is already in flight, and not onto your own lane. */
export function laneChangeAllowed({ changing, current, target }) {
  if (changing) return false;
  return target !== current;
}

/**
 * Which lane a one-press steer means. The road runs away from the camera going UP the
 * screen, so 'up' is the FAR lane ('left', the one you drive in heading left) and 'down'
 * the near one ('right'). Nothing else about the press matters — not which way you face,
 * not how fast you go: one press, one lane.
 */
export function laneForDir(dir) {
  return dir === 'up' ? 'left' : 'right';
}
